import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import API_URL from './api/config';


function ForgotPasswordReset() {

    const verifyCode = localStorage.getItem('verify_code');

    const [values, setValues] = useState({ password: '', confirm_password: '' });
    const navigate = useNavigate();
    axios.defaults.withCredentials = true;


    const handlePasswordReset = (e) => {
        e.preventDefault();
      
        axios.post(`${API_URL}/forgot-password-updatepassword-api`, {
            verify_code: verifyCode, password: values.password, confirm_password: values.confirm_password
        })
        .then(res => {
          if (res.data.Status === "Success") {
            toast.success("Password reset successful", { position: "top-right", autoClose: 3000 });
            localStorage.removeItem('verify_code');
            navigate(res.data.redirect);
          } else {
            toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
          }
        })
        .catch(() => {
          toast.error("An error occurred. Please try again.", { position: "top-right", autoClose: 3000 });
        });
      };
      
      

      
    return (
        <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center">
    <ToastContainer />
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-6">

                <div className="bg-med-green text-white p-4 rounded">
                    <div className="card-body text-center">
                        <div className="py-3">
                            <img src="img/logo_1.png" alt="" height="48" />
                        </div>

                        <form onSubmit={handlePasswordReset}>
                            <div className="row g-3">
                            
                            
                                <div className="col-12">
                                    <label>New Password</label>
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        onChange={e => setValues({ ...values, password: e.target.value })} 
                                        required 
                                    />
                                    <label>Confirm New Password</label>
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        onChange={e => setValues({ ...values, confirm_password: e.target.value })} 
                                        required 
                                    />
                                </div>
                               
                                
                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary w-100">Update Password</button>
                                </div>
                            </div>
                        </form>

                        <p class="text-center text-white" style={{marginTop: '10%'}}>
                        Already have an account?
                            <Link to="/" style={{color: '#184A2C', textDecoration: 'none'}}> Login</Link>
                        </p>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

    );
}

export default ForgotPasswordReset;
